import { RateLocationMapper } from "../rate-location/rate-location.mapper";
import { RateLocation } from "../rate-location/rate-location.type";
import { RateSurchargeBase } from "./rate-surcharge-base.model";
import { SurchargeType } from "../../surcharge-type/surcharge-type.model";
import { SurchargeTypeMapper } from "../../surcharge-type/surcharge-type.mapper";

export class AirRateSurcharge extends RateSurchargeBase {
  constructor(
    protected id: number,
    protected discriminator: string,
    protected surchargeType: SurchargeType,
    protected rateOriginLocations: RateLocation[],
    protected rateDestinationLocations: RateLocation[],
    protected weightPrice: number,
  ) {
    super(
      id,
      discriminator,
      surchargeType,
      rateOriginLocations,
      rateDestinationLocations,
    );
  }

  public getWeightPrice(): number {
    return this.weightPrice;
  }

  public setWeightPrice(param: number): void {
    this.weightPrice = param;
  }

  public getClone(): AirRateSurcharge {
    return new AirRateSurcharge(
      this.getId(),
      this.getDiscriminator(),
      SurchargeTypeMapper.map(this.getSurchargeType()),
      this.getRateOriginLocations()
        ? this.getRateOriginLocations().map(RateLocationMapper.map)
        : [],
      this.getRateDestinationLocations()
        ? this.getRateDestinationLocations().map(RateLocationMapper.map)
        : [],
      this.getWeightPrice(),
    );
  }

  public isValid(): boolean {
    return !!this.getSurchargeType();
  }
}
